import { h, Component } from "preact";

class BetaSwitch extends Component {
  constructor(props) {
    super(props);
  }
  render({ beta, toggleBeta }) {
    return (
      <div class="beta-switch">
        <label class={`checkbox${this.props.beta ? " checked" : ""}`}>
          <span class="label-text">Console mode</span>
          <input
            id="beta-switch"
            type="checkbox"
            name="beta-switch"
            checked={beta}
            onClick={toggleBeta}
            aria-checked={beta}
          />
          <span class="toggle">
            <span class={`option ${!beta ? " active" : ""}`}>
              Legacy
            </span>
            <span class={`option ${beta ? " active" : ""}`}>
              New
            </span>
          </span>
        </label>
      </div>
    );
  }
}
export default BetaSwitch;



// WEBPACK FOOTER //
// ./src/BetaSwitch.js